
/**
 * @file 接入 昊天镜 风控，获取jt
 * @author lijie44
 */
// @ts-ignore
import xaf from '@baidu/antifraud-xaf3';
import {sendYaLog} from '@lib/log';

export default (): Promise<string> => {
    return new Promise(resolve => {
        let done = false;
        try {
            const xafData = {
                aid: '12909',
                complete: (res: any) => {
                    sendYaLog(`get_xaf_jt_data_${JSON.stringify(res)}`);
                    if (done) {
                        return;
                    }
                    done = true;
                    const {code, jt} = res;

                    if (+code === 0 && jt) {
                        resolve(encodeURIComponent(jt));
                    }
                    else {
                        resolve('');
                    }
                },
                timeout: 200,
            };

            xaf.report(xafData);
            // 200ms 超时
            setTimeout(() => {
                if (!done) {
                    done = true;
                    sendYaLog('get_xaf_jt_timeout', 'net');
                    resolve('');
                }
            }, 200);

        }
        catch (error) {
            resolve('');
        }
    });
};
